// components/MobileNavigation/index.tsx
import React, { useState } from 'react';
import { navDropdownData } from '../NavbarData';
import NavigationItem from './NavigationItem';
import LoginButton from './LoginButton'; // Fixed import path
import { MobileNavigationProps } from './navigation';
import { useAccountStore } from '../../../store/useAccountStore';
import { Link, useNavigate } from 'react-router-dom';
import { LayoutDashboard, LogOut } from 'lucide-react';

const MobileNavigation: React.FC<MobileNavigationProps> = ({
  navItems,
  activeItem,
  isMobileMenuOpen,
  onNavClick
}) => {
  const [expandedItems, setExpandedItems] = useState<string[]>([]);
  const { user, clearUser } = useAccountStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    clearUser();
    navigate("/");
  };

  const toggleDropdown = (itemId: string) => {
    setExpandedItems(prev =>
      prev.includes(itemId)
        ? [] // Close current dropdown
        : [itemId] // Close all and open only the clicked one
    );
  };

  const hasDropdown = (itemId: string) => {
    return navDropdownData[itemId] && navDropdownData[itemId].length > 0;
  };

  const isExpanded = (itemId: string) => {
    return expandedItems.includes(itemId);
  };

  return (
    <div
      className={`lg:hidden bg-white border-t border-gray-200 shadow-xl transition-all duration-300 ease-in-out ${isMobileMenuOpen
          ? "max-h-screen opacity-100 visible"
          : "max-h-0 opacity-0 invisible overflow-hidden"
        }`}
    >
      <div className="px-4 pt-4 pb-6 space-y-2 max-h-[85vh] overflow-y-auto">
        <div className="space-y-2">
          {navItems.map((item) => (
            <NavigationItem
              key={item.id}
              item={item}
              activeItem={activeItem}
              onNavClick={onNavClick}
              hasDropdown={hasDropdown(item.id)}
              isExpanded={isExpanded(item.id)}
              onToggleDropdown={toggleDropdown}
              dropdownData={navDropdownData[item.id]}
            />
          ))}
        </div>

        {user?.name ? (
          <div className="mt-4 pt-4 border-t border-gray-200 space-y-3">
            {/* Portal Hub Link */}
            <Link
              to="/select-dashboard"
              className="flex items-center gap-2 w-full py-3 px-4 bg-navgreen text-white font-medium rounded-md transition-all duration-300 hover:shadow-lg"
            >
              <LayoutDashboard size={20} />
              <span>Portal Hub</span>
            </Link>

            {/* User Info */}
            <div className="flex items-center gap-2 px-4">
              <img src="assets/user-4.svg" className="w-8 h-8" />
              <p className="font-medium">{user.name}</p>
            </div>

            {/* Logout Button */}
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 w-full py-2 px-4 text-red-600 font-medium hover:bg-red-50 rounded-md transition-colors"
            >
              <LogOut size={18} />
              <span>Logout</span>
            </button>
          </div>
        ) : (
          <div className="mt-4 pt-4 border-t border-gray-200">
            <LoginButton />
          </div>
        )}

      </div>
    </div>
  );
};

export default MobileNavigation;